import { trendTimeline, trendTopics } from "@/mocks/chigua";

export default function TrendSection() {
  return (
    <section id="trend" className="scroll-mt-28 bg-paper">
      <div className="mx-auto w-full max-w-7xl px-4 py-16 md:px-6">
        <div className="mb-9 flex flex-col gap-4 sm:flex-row sm:items-end sm:justify-between">
          <div>
            <span className="inline-flex items-center gap-1.5 rounded-full bg-ember/10 px-3 py-1 text-xs font-bold text-ember">
              <i className="ri-fire-line" />
              传播节奏 · 判断事件到哪一步
            </span>
            <h2 className="mt-3 font-display-x text-3xl font-black md:text-4xl">
              一眼看懂事件在什么阶段
            </h2>
            <p className="mt-2 max-w-2xl text-sm leading-relaxed text-ink/60 md:text-base">
              吃瓜最怕搞不清进度。我们把每件事标好处于哪个阶段、当下热度多少，跟着节奏走就不会落后或乱带风向。
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 gap-8 lg:grid-cols-[1fr_1.15fr]">
          {/* 热度话题列表（密） */}
          <div className="rounded-3xl bg-cream p-6 ring-1 ring-sand/60 md:p-8">
            <div className="flex items-center justify-between">
              <h3 className="font-display-x text-xl font-bold">本周热议榜</h3>
              <span className="flex items-center gap-1.5 text-xs font-semibold text-ember">
                <i className="ri-flashlight-line" />
                实时
              </span>
            </div>
            <div className="mt-6 space-y-5">
              {trendTopics.map((t, i) => (
                <div key={t.label}>
                  <div className="flex items-center justify-between text-sm">
                    <span className="flex items-center gap-2 font-semibold text-ink">
                      <span className="flex h-6 w-6 items-center justify-center rounded-md bg-peach text-xs font-black text-ember">
                        {i + 1}
                      </span>
                      {t.label}
                    </span>
                    <span className="text-xs text-ink/50">热度 {t.hot}</span>
                  </div>
                  <div className="mt-2 h-2 w-full overflow-hidden rounded-full bg-sand">
                    <div
                      className="h-full rounded-full bg-gradient-to-r from-ember to-amber"
                      style={{ width: `${t.hot}%` }}
                    />
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* 阶段时间线（疏） */}
          <div className="relative rounded-3xl bg-ink p-6 text-cream md:p-8">
            <h3 className="font-display-x text-xl font-bold">事件推进时间线</h3>
            <p className="mt-2 text-sm text-cream/60">
              按起、涨、热、顶、散标记，同一主题的素材分阶段归档。
            </p>
            <div className="relative mt-8 space-y-0">
              {trendTimeline.map((step, i) => (
                <div key={step.time} className="relative flex gap-4 pb-7 last:pb-0">
                  {i < trendTimeline.length - 1 && (
                    <span className="absolute left-[11px] top-6 h-full w-px bg-cream/20" />
                  )}
                  <span
                    className={`relative z-10 mt-1 flex h-6 w-6 shrink-0 items-center justify-center rounded-full text-[10px] font-black ${
                      i === 3 ? "bg-amber text-ink" : "bg-ember text-cream"
                    }`}
                  >
                    {i + 1}
                  </span>
                  <div className="flex flex-1 items-start justify-between gap-3">
                    <div>
                      <p className="text-[11px] font-bold uppercase tracking-wider text-amber/90">
                        {step.time}
                      </p>
                      <p className="mt-1 text-sm leading-relaxed text-cream/85">{step.label}</p>
                    </div>
                    <span className="whitespace-nowrap rounded-full bg-cream/10 px-2.5 py-1 text-[11px] text-cream/70">
                      {step.hot}
                    </span>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}